/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import * as types from './mutation-types';
import ApiService from '@/services/commonApi';
import { HOME, GETLOCALITIES, PROJECTFAVOURITE, FOOTERPROJECTS, PROJECTDETAILS, GETTAGS, SITEVISIT, BID, GETNOTIFICATIONS, EDITNOTIFICATIONS, PAYMENTDETAILS, BOOK, CANCELBOOKING, GETBIDSTRENGTH, GETCOMPAREPROJECT, GETPROJECTLIST, UNITDETAILS, SEARCHDETAILS, STATISTICS, GETEXCLUSIVEPROJECTS, WITHDRAWBID } from '@/utils/endpoint';
import store from '@/store';
import { router } from '@/plugins/vue-router';

const home = ({ commit }, payload) => {
  let apiUrl = HOME;
  const city = store.state.home.city;
  if (city && city !== 'All City')
    apiUrl = `${HOME}?city=${city}`;
  if (payload && payload.city !== 'All City')
    apiUrl = `${HOME}?city=${payload.city}`;
  ApiService.get(apiUrl)
    .then((response) => {
      commit(types.HOME, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const favProjects = ({ commit }) => {
  ApiService.get(PROJECTFAVOURITE)
    .then((response) => {
      commit(types.FAVPROJECTS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const addFavProjects = ({ commit }, payload) => {
  ApiService.post(PROJECTFAVOURITE, payload.data)
    .then((response) => {
      let dataToAdd;
      if (payload.data.type === 'unit') {
        dataToAdd = {
          project_id: payload.project_id,
          unit_id: payload.data.id,
          fav_id: response.fav_id,
        };
      } else {
        dataToAdd = {
          project_id: payload.data.id,
          fav_id: response.fav_id,
        };
      }
      commit(types.ADDFAVPROJECTS, dataToAdd);
      if (payload.cb_success)
        payload.cb_success(dataToAdd);
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

const setOverlayActive = ({ commit }, payload) => {
  commit(types.SETOVERLAYSTATE, payload);
};

const getLocalities = ({ commit }) => {
  ApiService.get(GETLOCALITIES)
    .then((response) => {
      commit(types.LOCALITIES, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getTags = ({ commit }) => {
  ApiService.get(GETTAGS)
    .then((response) => {
      commit(types.TAGS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const deleteFavProjects = ({ commit }, payload) => {
  ApiService.deleteWithParams(PROJECTFAVOURITE, payload.data)
    .then(() => {
      commit(types.DELETEFAVPROJECTS, { fav_id: payload.data.id, isUnit: payload.isUnit });
      if (payload.cb_success)
        payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

const getProjectDetails = ({ commit }, payload) => {
  const details = store.state.home.projectDetails;
  if (payload.data.forceGet || !details || details.project_id !== payload.data.id) {
    ApiService.get(`${PROJECTDETAILS}${payload.data.id}/`)
      .then((response) => {
        response.project_id = payload.data.id;
        commit(types.PROJECTDETAILS, response);
      })
      .catch((error) => {
        payload.cb_error(error);
      });
  }
};

const getUnitDetails = ({ commit }, payload) => {
  const apiUrl = UNITDETAILS.replace('id', payload.id);
  ApiService.get(apiUrl)
    .then((response) => {
      response.project_id = payload.id;
      commit(types.SETUNITDETAILS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSiteDRM = ({ commit }, payload) => {
  ApiService.get(`${SITEVISIT}?project_id=${payload.id}`)
    .then((response) => {
      commit(types.SITEDRM, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const addSiteVisit = ({ _commit }, payload) => {
  ApiService.post(SITEVISIT, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

const editSiteVisit = ({ _commit }, payload) => {
  ApiService.put(`${SITEVISIT}${payload.data.id}/`, payload.data)
    .then(() => {
      payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

const deleteSiteVisit = ({ _commit }, payload) => {
  ApiService.delete(`${SITEVISIT}${payload.data.id}/`, payload.data)
    .then(() => {
      payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error();
      console.log(error);
    });
};

const placeBid = ({ _commit }, payload) => {
  ApiService.post(BID, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};

const reviseBid = ({ _commit }, payload) => {
  ApiService.put(BID, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};

const updateBid = ({ commit }, payload) => {
  commit(types.UPDATEBID, payload);
};

const book = ({ _commit }, payload) => {
  ApiService.post(BOOK, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

const getNotifications = ({ commit, _state }) => {
  ApiService.get(GETNOTIFICATIONS)
    .then((response) => {
      commit(types.GETNOTIFICATIONS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const addNotifications = ({ commit }, payload) => {
  commit(types.ADDNOTIFICATIONS, payload);
};

const updateNotifications = ({ commit, _state }, payload) => {
  ApiService.put(EDITNOTIFICATIONS, payload.data)
    .then(() => {
      commit(types.UPDATENOTIFICATIONS, payload);
      payload.cb_success();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getPaymentDetails = ({ _commit }, payload) => {
  ApiService.post(PAYMENTDETAILS, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      console.log(error);
      payload.cb_error(error);
    });
};

const cancelBooking = ({ _commit }, payload) => {
  ApiService.post(CANCELBOOKING, payload.data)
    .then((response) => {
      payload.cb_success(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getBidStrength = ({ commit }, payload) => {
  ApiService.post(GETBIDSTRENGTH, payload)
    .then((response) => {
      const bidStrength = {
        strength: response,
      };
      commit(types.GETBIDSTRENGTH, bidStrength);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getFooterProjects = ({ commit, state }) => {
  if (!state.footerProjects) {
    ApiService.get(FOOTERPROJECTS)
      .then((response) => {
        commit(types.FOOTERPROJECTS, response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

const resetToDefaultState = ({ commit }) => {
  commit(types.RESET);
};

const showWonLostBid = ({ commit }, payload) => {
  commit(types.SHOWWONLOSTBID, payload);
  if (payload.bid.status === 'Lost')
    localStorage.setItem(`${payload.bid.project_id}_bid_lost`, true);
};

const setCity = ({ commit }, payload) => {
  commit(types.SETCITY, payload);
};

const compareProject = ({ commit }, payload) => {
  const data = payload.join();
  ApiService.get(`${GETCOMPAREPROJECT}?projects=${data}`)
    .then((response) => {
      commit(types.SETCOMPAREDATA, response);
    })
    .catch((error) => {
      console.log(error);
    });
};
const getProjectList = ({ commit }) => {
  ApiService.get(GETPROJECTLIST)
    .then((response) => {
      commit(types.SETPROJECTLIST, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateFavUnit = ({ commit }, payload) => {
  ApiService.post(PROJECTFAVOURITE, payload.data)
    .then((response) => {
      const dataToAdd = {
        display_text: payload.unit_name,
        unit_id: payload.data.id,
        fav_id: response.fav_id,
      };
      commit(types.ADDFAVUNITS, dataToAdd);
      if (payload.cb_success)
        payload.cb_success(dataToAdd);
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};

const deleteFavUnit = ({ commit }, payload) => {
  ApiService.deleteWithParams(PROJECTFAVOURITE, payload.data)
    .then(() => {
      commit(types.DELETEFAVUNITS, { fav_id: payload.data.id });
      if (payload.cb_success)
        payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
    });
};

const getListingPageData = ({ commit }, payload) => {
  ApiService.get(SEARCHDETAILS, payload.query, true)
    .then((response) => {
      commit(types.GETLISTINGDATA, response);
      if (payload.cb_success)
        payload.cb_success(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateListingProjects = ({ commit }, payload) => {
  commit(types.GETLISTINGDATA, payload);
};

const getExculsiveProjects = ({ commit }, payload) => {
  ApiService.get(GETEXCLUSIVEPROJECTS, payload.query, true)
    .then((response) => {
      commit(types.GETLISTINGDATA, response);
      if (payload.cb_success)
        payload.cb_success(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateProject = ({ commit }, payload) => {
  commit(types.UPDATEPROJECT, payload);
  if (payload.project.auction_status === 'CLOSED' && router.currentRoute.name === 'home.projectdetails'
  && parseInt(router.currentRoute.query.id, 10) === payload.project.id && !localStorage.getItem(`${payload.project.id}_bid_lost`))
    commit(types.SHOWAUCTIONLOST, payload);
};

const getStats = ({ commit }) => {
  ApiService.get(STATISTICS)
    .then((response) => {
      commit(types.UPDATESTATS, response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateStats = ({ commit }, payload) => {
  commit(types.UPDATESTATS, payload);
};

const updateUnit = ({ commit }, payload) => {
  commit(types.UPDATEUNITS, payload);
};

const updateLocality = ({ commit }, payload) => {
  commit(types.FOOTERPROJECTS, payload);
};

const updateFavUnitSignal = ({ commit }, payload) => {
  commit(types.UPDATEFAVUNITSIGNAL, payload);
};
const removeSoldUnit = ({ commit }, payload) => {
  commit(types.REMOVESOLDUNIT, payload);
};

const withdrawUserBid = ({ _commit }, payload) => {
  const apiUrl = WITHDRAWBID.replace('bid-id', payload.id);
  ApiService.put(apiUrl)
    .then(() => {
      payload.cb_success();
    })
    .catch((error) => {
      payload.cb_error(error);
      console.log(error);
    });
};

export default {
  home,
  favProjects,
  addFavProjects,
  deleteFavProjects,
  getProjectDetails,
  addSiteVisit,
  deleteSiteVisit,
  editSiteVisit,
  placeBid,
  reviseBid,
  getNotifications,
  addNotifications,
  updateNotifications,
  getPaymentDetails,
  book,
  updateBid,
  cancelBooking,
  getBidStrength,
  getFooterProjects,
  getLocalities,
  getTags,
  setOverlayActive,
  resetToDefaultState,
  showWonLostBid,
  getSiteDRM,
  setCity,
  compareProject,
  getProjectList,
  getUnitDetails,
  updateFavUnit,
  deleteFavUnit,
  getListingPageData,
  updateListingProjects,
  getExculsiveProjects,
  updateProject,
  updateStats,
  getStats,
  updateUnit,
  updateLocality,
  updateFavUnitSignal,
  removeSoldUnit,
  withdrawUserBid,
};



// WEBPACK FOOTER //
// ./src/store/modules/home/actions.js